import { Navigate, Route, Routes } from 'react-router-dom'

/* Styles */
import './common/css/font.css'
import './App.css'

/*** HomePage ***/
/* Layouts */
import HomepageLayout from './layouts/homepage/HomepageLayout'
import RecommendLayout from './components/recommend/RecommendLayout'

/* pages */
import Main from './components/main/Main'
import Login from './pages/user/login/Login'
import Signup from './pages/user/signup/Signup'
import Mypage from './pages/user/mypage/Mypage'

import Record from './pages/recommend/record/Record'
import Result from './pages/recommend/result/Result'
import Lecture from './pages/recommend/lecture/Lecture'

import SchoolRecordLayout from './pages/schoolRecord/SchoolRecordLayout'
import SchoolRecordListPage from './pages/schoolRecord/SchoolRecordListPage'

import SurveyLayout from './pages/survey/SurveyLayout'
import SurveyFormPage from './pages/survey/SurveyFormPage'
import SurveyTestPage from './pages/survey/SurveyTestPage'
import SurveyReportPage from './pages/survey/SurveyReportPage'

import TermsOfService from './components/common/TermsOfService'
import Policy from './components/common/Policy'

/* Components */
import ProtectedRoute from './components/common/ProtectedRoute'

/***  AdminPage ***/
import AdminpageLayout from './layouts/adminpage/AdminpageLayout'
import AdminProtectedRoute from './components/admin/common/AdminProtectedRoute'
import AdminMain from './pages/admin/AdminMain'
import AdminLogin from './pages/admin/adminUser/AdminLogin'

import AdminLectures from './pages/admin/lectures/AdminLectures'

import AdminSurveyList from './pages/admin/survey/AdminSurveyList'
import AdminSurveyFormRead from './pages/admin/survey/AdminSurveyFormRead'
import AdminSurveyReportRead from './pages/admin/survey/AdminSurveyReportRead'
import AdminSurveyReportWrite from './pages/admin/survey/AdminSurveyReportWrite'

import AdminProtectedRouteUserType from './components/admin/common/AdminProtectedRouteUserType'
import AdminCounselMain from './pages/admin/counsel/AdminCounselMain'
import AdminCounselList from './pages/admin/counsel/AdminCounselList'
import AdminCounselWrite from './pages/admin/counsel/AdminCounselWrite'
import AdminCounselRead from './pages/admin/counsel/AdminCounselRead'

import AdminSchoolRecordMain from './pages/admin/schoolRecord/AdminSchoolRecordMain'
import AdminSchoolRecordListPage from './pages/admin/schoolRecord/AdminSchoolRecordListPage'
import AdminSchoolRecordWritePage from './pages/admin/schoolRecord/AdminSchoolRecordWritePage'
import AdminSchoolRecordVer1ReadPage from './pages/admin/schoolRecord/AdminSchoolRecordVer1ReadPage'
import SchoolRecordReadPage from './pages/schoolRecord/SchoolRecordReadPage'
import AdminChattingMain from './pages/admin/chat/AdminChattingMain'
import MypageLayout from './layouts/homepage/MypageLayout'
import ChatPage from './pages/chat/ChatPage'
import FilePage from './pages/file/FilePage'
import AdminSchoolRecordVer2ReadPage from './pages/admin/schoolRecord/AdminSchoolRecordVer2ReadPage'

function App() {
  return (
    <>
      <Routes>
        {/* ----------🧑‍💻 Homepage ---------- */}
        <Route element={<HomepageLayout />}>
          {/* Homepage > Public */}
          <Route path="/" index element={<Main />} />

          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/policy" element={<Policy />} />

          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          {/* Homepage > App */}
          <Route element={<ProtectedRoute />}>
            {/* <Route path="/recommend" element={<RecommendLayout />}>
                <Route path="record" element={<Record />} />
                <Route path="result" element={<Result />} />
                <Route path="lecture" element={<Lecture />} />
            </Route> */}

            {/* <Route path="/school-record" element={<SchoolRecord />} /> */}
            <Route path="/school-record" element={<SchoolRecordLayout />}>
              <Route index element={<SchoolRecordListPage />} />
              <Route path=":schoolRecordId" element={<SchoolRecordReadPage />} />
            </Route>

            <Route path="/survey" element={<SurveyLayout />}>
              <Route path="form" element={<SurveyFormPage />} />
              <Route path="test" element={<SurveyTestPage />} />
              <Route path="report" element={<SurveyReportPage />} />
            </Route>

            <Route path="/mypage" element={<MypageLayout />}>
              <Route index element={<Mypage />} />
              <Route path="chat" element={<ChatPage />} />
              <Route path="file" element={<FilePage />} />
            </Route>
          </Route>
        </Route>

        {/* ----------🧑‍💻 Adminpage ---------- */}
        <Route path="/hy-admin/login" element={<AdminLogin />} />
        <Route element={<AdminpageLayout />}>
          <Route element={<AdminProtectedRoute />}>
            {/* Main */}
            {/* <Route path="/hy-admin" index element={<AdminMain />} /> */}

            {/* 임시 main redirect */}
            <Route path="/hy-admin" index element={<Navigate to="/hy-admin/survey" replace />} />

            {/* Lecture */}
            {/* <Route path="/hy-admin/lectures" element={<AdminLectures />} /> */}

            {/* Survey */}
            <Route path="/hy-admin/survey" element={<AdminSurveyList />} />
            <Route path="/hy-admin/survey/form/:userId" element={<AdminSurveyFormRead />} />
            <Route path="/hy-admin/survey/report/:userId" element={<AdminSurveyReportRead />} />
            <Route element={<AdminProtectedRouteUserType userType={['master', 'admin']} />}>
              <Route path="/hy-admin/survey/report/write/:userId" element={<AdminSurveyReportWrite />} />
            </Route>

            {/* Counsel */}
            <Route path="/hy-admin/counsel" element={<AdminCounselMain />} />
            <Route path="/hy-admin/counsel/list/:userId" element={<AdminCounselList />} />
            <Route element={<AdminProtectedRouteUserType userType={['master', 'teacher', 'admin']} />}>
              <Route path="/hy-admin/counsel/write/:userId" element={<AdminCounselWrite writeType="write" />} />
              <Route
                path="/hy-admin/counsel/update/:userId/:counselId"
                element={<AdminCounselWrite writeType="update" />}
              />
            </Route>
            <Route path="/hy-admin/counsel/read/:userId/:counselId" element={<AdminCounselRead />} />

            {/* School Record */}
            <Route path="/hy-admin/school-record" element={<AdminSchoolRecordMain />} />
            <Route path="/hy-admin/school-record/list/:userId" element={<AdminSchoolRecordListPage />} />
            <Route element={<AdminProtectedRouteUserType userType={['admin']} />}>
              <Route
                path="/hy-admin/school-record/write/:userId"
                element={<AdminSchoolRecordWritePage writeType="write" />}
              />
              <Route
                path="/hy-admin/school-record/update/:userId/:schoolRecordId"
                element={<AdminSchoolRecordWritePage writeType="update" />}
              />
            </Route>
            <Route
              path="/hy-admin/school-record/old-read/:userId/:schoolRecordId"
              element={<AdminSchoolRecordVer1ReadPage />}
            />
            <Route
              path="/hy-admin/school-record/read/:userId/:schoolRecordId"
              element={<AdminSchoolRecordVer2ReadPage />}
            />

            {/* Chatting */}
            <Route path="/hy-admin/chatting" element={<AdminChattingMain />} />
          </Route>
        </Route>

        {/* Not Found */}
        <Route path="/hy-admin/*" element={<Navigate to="/hy-admin" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}

export default App
